import { Slider } from 'components/molecules/Slider'
import { Card } from 'components/organisms/Card'
import { Section } from 'components/organisms/Section'
import type { WhyUsProps } from './types'

import './index.scss'

const mainClass = 'why-us'

export const WhyUs = ({
  title,
  subtitle,
  note,
  action,
  list = [],
  modifier = 'card--secondary',
}: WhyUsProps) => {
  return (
    <Section
      id="_whyus"
      className={mainClass}
      title={title}
      subtitle={subtitle}
      note={note}
      action={action}
    >
      {list.length > 0 && (
        <Slider variableWidth className={`${mainClass}__slider`}>
          {list.map((item) => (
            <Card
              key={item.id}
              title={item.title}
              text={item.text}
              image={item.image}
              modifier={modifier}
            />
          ))}
        </Slider>
      )}
    </Section>
  )
}
